import {Component} from '@angular/core';

@Component({
  selector: 'pt-loader',
  template: `
    <div class='text-center' style='color: var(--ptBorder)'>
      <div class='spinner-border' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
    </div>
  `
})
export class LoaderComponent {
}
